import { InfoFilled } from '@ifood/pomodoro-icons';
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl';
import React from 'react';

import { SlugField, TooltipContent } from './styles';

export const SlugInformation = (): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <SlugField>
      <FormattedMessage id="fields.slug" />
      <TooltipContent content={formatMessage({ id: 'sign-up.form.slug-description' })} trigger="hover">
        <InfoFilled />
      </TooltipContent>
    </SlugField>
  );
};
